import type { DetailProcess } from '@/pages/integrations/detail/[id]/types';
import type { UseFormReturn } from 'react-hook-form';
import type * as yup from 'yup';

export function getFormMethodsFromContext(
  context: yup.TestContext<yup.AnyObject>,
): UseFormReturn<DetailProcess> {
  return context.options.context?.getFormMethods?.();
}

export function getParentPath(path: string): string {
  return path.split('.').slice(0, -1).join('.');
}

export function formatPrefix(label: string) {
  return `[${label}]`;
}

export function formatValueInvalidWithPrefix(prefix: string, v: string) {
  return `${formatPrefix(prefix)} ${v} is invalid`;
}
export function formatValueWithPrefix(prefix: string, v: string) {
  return `${formatPrefix(prefix)} ${v}`;
}
